import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { QueryClient, QueryClientProvider, Query } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import * as React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';

import './../../semafone/jquery.ba-postmessage.js';
import './../../semafone/semafone-ecommerce-feedback.js';
import './../../semafone/semafone-ecommerce-min.js';
import './../../semafone/jquery-migrate-1.2.1.min.js';
import './../../semafone/rogers-to-semafone-ecommercejs.js';

import ExpressCheckout from './checkout.component';
const checkoutElement = document.getElementById('expressCheckout') as HTMLElement;

export const NO_PERSIST_PREFIX = 'noPersist';

export const shouldDehydrateQuery = (query: Query) => {
    const firstKey = query.queryKey[0];
    return typeof firstKey !== 'string' || !firstKey.startsWith(NO_PERSIST_PREFIX);
};
// strict mode disabled until react-sticky-el plugin resolves its issue with it
// https://github.com/gm0t/react-sticky-el/issues/82
// Initialize QueryClient and persister
const client = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: Infinity,
            cacheTime: 1000 * 60 * 60 * 24, // 24 hours
        },
    },
});
const persister = createSyncStoragePersister({
    storage: window.localStorage,
});

if (checkoutElement) {
    const root = ReactDOM.createRoot(checkoutElement);
    root.render(
        // <React.StrictMode>
        <PersistQueryClientProvider
            client={client}
            persistOptions={{
                persister,
                dehydrateOptions: {
                    shouldDehydrateQuery,
                },
            }}
        >
            <ReactQueryDevtools initialIsOpen={false} />
            <ExpressCheckout />,
        </PersistQueryClientProvider>,
        // </React.StrictMode>,
    );
}
